function entranceJump(href) {
  console.log(href)
  //处理href，获取跳转路径
  if (href.indexOf("/#/?") != -1) {
    //获取需要刷新token的参数
    let initToken = getUrlQuery('token', href),
      initBusType = getUrlQuery('busType', href);
    window.localStorage.setItem("initToken", initToken)
    window.localStorage.setItem("initBusType", initBusType)
    //处理参数
    let toHerf = decodeURIComponent(href).split("?")[1].split("&")[0];
    let friendid = getUrlQuery('friendid', href),
      wechatid = getUrlQuery('wechatid', href),
      dialogType = getUrlQuery('dialogType', href),
      showType = getUrlQuery('showType', href),
      hideheader = getUrlQuery('hideheader', href),
      outsideTableId = getUrlQuery('outsideTableId', href),
      isrechoose = getUrlQuery('isrechoose', href),
      outsideTable = getUrlQuery('outsideTable', href);
    sessionStorage.setItem('hideheader', hideheader)
    if (friendid || hideheader) {
      return {
        path: `/${toHerf}`,
        query: {
          friendid: friendid,
          wechatid: wechatid,
          dialogType: dialogType,
          showType: showType,
          hideheader: hideheader,
          outsideTable: outsideTable,
          outsideTableId: outsideTableId,
          isrechoose: isrechoose
        }
      }

    } else {
      return {path: `/${toHerf}`}
    }
  } else {
    let toHerf = decodeURIComponent(href).split("/#/")[1];
    return {path: `/${toHerf}`}
  }
}

function getUrlQuery(name, url) {
  var query = url.split("?")[1];
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == name) {
      return pair[1];
    }
  }
  return (false);
}

/*
*
* */
function isObject(value) {
  const type = typeof value
  return value != null && (type == 'object' || type == 'function')
}
/**
 * @desc 弱链接深拷贝，结构化拷贝，支持string,number,date,reg等格式，不支持function拷贝
 * @param {Any} obj
 * @param {WeakMap} hash
 * @return {Any}
 */
function deepClone(obj, hash = new WeakMap()) {
  if ((obj == null) || ("object" != typeof obj)) return obj;
  let cloneObj
  let Constructor = obj.constructor
  switch (Constructor) {
    case RegExp:
      cloneObj = new Constructor(obj)
      break
    case Date:
      cloneObj = new Constructor(obj.getTime())
      break
    default:
      if (hash.has(obj)) return hash.get(obj)
      cloneObj = new Constructor()
      hash.set(obj, cloneObj)
  }
  for (let key in obj) {
    cloneObj[key] = isObject(obj[key]) ? deepClone(obj[key], hash) : obj[key];
  }
  return cloneObj
}
export{
  deepClone,
  getUrlQuery,
  entranceJump
}



// WEBPACK FOOTER //
// ./src/utils/fristJump.js